import { render } from "./TableOfContents.vue?vue&type=template&id=fadefdb2"
import script from "./TableOfContents.vue?vue&type=script&lang=js"
export * from "./TableOfContents.vue?vue&type=script&lang=js"

import "./TableOfContents.vue?vue&type=style&index=0&id=fadefdb2&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__